import { render } from "./LegendItem.vue?vue&type=template&id=1836f4fc&scoped=true"
import script from "./LegendItem.vue?vue&type=script&lang=js"
export * from "./LegendItem.vue?vue&type=script&lang=js"

import "./LegendItem.vue?vue&type=style&index=0&id=1836f4fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\schmidch\\IdeaProjects\\soilmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1836f4fc"]])

export default __exports__